import { render, staticRenderFns } from "./operating-record.vue?vue&type=template&id=20348d4e&scoped=true&"
import script from "./operating-record.vue?vue&type=script&lang=js&"
export * from "./operating-record.vue?vue&type=script&lang=js&"
import style0 from "./operating-record.vue?vue&type=style&index=0&id=20348d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20348d4e",
  null
  
)

export default component.exports